import React, { memo } from 'react';
export function EmotionalClosing() {
  return <section className="bg-warm-mid py-16 md:py-20 px-4" data-id="element-70">
      <div className="max-w-3xl mx-auto text-center" data-id="element-71">
        {/* Heading */}
        <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-warm-hero mb-8 leading-tight" data-id="element-72">
          Because these are not just photos —{' '}
          <span className="italic text-soft-gold" data-id="element-73">they're memories</span>
        </h2>

        {/* Image */}
        <div className="mb-8 rounded-2xl overflow-hidden shadow-xl max-w-2xl mx-auto" data-id="element-74">
          <img src="https://images.unsplash.com/photo-1450778869180-e77d3c79db18?w=900&h=600&fit=crop&crop=faces" alt="Dog owner smiling while looking at beautiful photos of their dog, warm golden light, sentimental and heartwarming" className="w-full h-auto object-cover" data-id="element-75" />
        </div>

        {/* Text below */}
        <p className="font-sans text-lg md:text-xl text-gray-800 max-w-2xl mx-auto leading-relaxed" data-id="element-76">
          Your dog will not stay exactly the same forever. The moments you
          capture now become{' '}
          <span className="font-semibold text-warm-hero" data-id="element-77">
            memories you'll be grateful to keep.
          </span>
        </p>
      </div>
    </section>;
}